export const UserRole = {
  Admin: 0,
  Editor: 1,
};

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'en';
export const localeOptions = [
  { id: 'en', name: 'English - LTR', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' },
  { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

// export const firebaseConfig = {
//   apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
//   authDomain: 'bahakel-react-login.firebaseapp.com',
//   databaseURL: 'https://bahakel-react-login.firebaseio.com',
//   projectId: 'bahakel-react-login',
//   storageBucket: 'bahakel-react-login.appspot.com',
//   messagingSenderId: '216495999563',
// };
export const firebaseConfig = {
  apiKey: "AIzaSyBPiSOEbEx19p2TQvsW5RrafcpLaxo_MTQ",
  authDomain: "incyte.bahakeldigitalmedia.com",
  projectId: "bdm-storage",
  storageBucket: "bdm-storage.appspot.com",
  messagingSenderId: "852058252989",
  appId: "1:852058252989:web:0fb53a93df736e3753b9d4",
  measurementId: "G-JZSR8J27R0"
};

export const adminRoot = '/app';

export const searchPath = `${adminRoot}/#`;


export const currentUser = {
  id: 1,
  title: 'Test User',
  img: '/assets/img/avatar.png',
  date: 'Last seen today',
  role: UserRole.Admin,
};

export const themeColorStorageKey = 'dark.greysteel';
export const isMultiColorActive = true;
export const defaultColor = 'dark.greysteel';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];
